import FlightPriceCard from './FlightPriceCard';

export default FlightPriceCard;
